import { render, staticRenderFns } from "./ResultImportCardStack.vue?vue&type=template&id=6e97898c"
import script from "./ResultImportCardStack.vue?vue&type=script&lang=js"
export * from "./ResultImportCardStack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports